import { CSSProperties, StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { NAV_BAR_WIDTH_COMPACT, NAV_BAR_WIDTH_EXPANDED } from '../../../constants/sizes';
import {
	dashboardNavBackground,
	dashboardNavGlowFade,
	dashboardNavGlowNavy,
	dashboardNavGlowPink,
} from '../../../styles/colors';
const { colors, spacing } = THEME;

const unreadTextMessageCount: CSSProperties = {
	alignItems: 'center',
	background: '#FF6175',
	boxSizing: 'border-box',
	color: '#fff',
	display: 'flex',
	justifyContent: 'center',
	width: 'auto',
};

/** `rightEdge` places the gradients' anchor; anything painting outside the nav passes the nav's width in px. */
export const navBackground = (rightEdge: string) =>
	`radial-gradient(1000px 700px at ${rightEdge} 0px, ${dashboardNavGlowNavy} 0%, ${dashboardNavGlowFade} 100%), radial-gradient(383px 607px at ${rightEdge} 201px, ${dashboardNavGlowPink} 0%, transparent 30%), linear-gradient(${dashboardNavBackground}, ${dashboardNavBackground})`;

export const styleSheet = StyleSheet.create({
	coffeeLogo: {
		height: 66,
		marginBottom: 10,
		width: 'auto',
	},
	compactUnreadTextMessageCount: {
		...unreadTextMessageCount,
		borderRadius: 7,
		fontSize: 10,
		height: 14,
		minWidth: 14,
		padding: '0 3px',
	},
	expandedTabIndicator: {
		':before': {
			left: 238, // button width + margin right to align with the edge of the nav container
		},
	},
	header: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		padding: '40px 0',
		position: 'relative',
		zIndex: 2,
	},
	levLogo: {
		height: 'auto',
		marginTop: 8,
		width: 'auto',
	},
	link: {
		':hover': {
			backgroundColor: 'rgba(84, 160, 215, 0.26)',
			borderRadius: '0.75rem',
		},
		':not(:first-child)': {
			marginTop: '0.5rem',
		},
		alignItems: 'center',
		boxSizing: 'border-box',
		color: 'white',
		display: 'flex',
		height: 40,
		padding: '0.25rem 1rem',
		position: 'relative',
		textDecoration: 'none',
		width: '100%',
	},
	links: {
		alignItems: 'flex-start',
		display: 'flex',
		flexDirection: 'column',
		position: 'relative',
		zIndex: 2,
		margin: spacing.sm,
	},
	linkActive: {
		':before': {
			background: colors.hover.main,
			content: '" "',
			display: 'block',
			height: 40,
			left: 44,
			position: 'absolute',
			width: 4,
			borderTopLeftRadius: 3,
			borderBottomLeftRadius: 3,
		},
		backgroundColor: 'rgba(84, 160, 215, 0.26)',
		borderRadius: '0.75rem',
	},
	linkCompact: {
		justifyContent: 'center',
	},

	logoContainer: {
		alignItems: 'center',
		color: '#aaa',
		display: 'flex',
		flexDirection: 'column',
		fontSize: 11,
		letterSpacing: '1.1px',
		marginBottom: 20,
		paddingTop: 20,
		textTransform: 'uppercase',
	},
	mainLogo: {
		maxHeight: 40,
		maxWidth: 200,
		width: '100%',
	},
	nav: {
		background: navBackground('100%'),
		height: '100%',
		width: NAV_BAR_WIDTH_COMPACT,
		overflowX: 'hidden',
		overflowY: 'auto',
		position: 'relative',
		zIndex: 0,
	},
	navExpanded: {
		width: NAV_BAR_WIDTH_EXPANDED,
	},
	unreadTextMessageCount: {
		...unreadTextMessageCount,
		borderRadius: 9,
		fontSize: 12,
		height: 18,
		minWidth: 18,
		padding: '0 5px',
	},
});
